<template>
  <v-container class="wrapper">
    <v-row justify="center">
      <v-col class="profile-cards">
        <v-card class="card-form">
          <v-card-title
            class="primary white--text headline background-gradient"
          >
            <v-icon class="white-icon">mdi-account-edit</v-icon>
            <span class="headline ml-3">Personal Information{{ profileSectionSuffix('personal') }}</span>
          </v-card-title>
          <v-card-text class="pt-2 pl-8 pr-6">
            <v-avatar size="100" class="display-inline">
              <v-img
                :src="
                  VUE_APP_API_ENDPOINT +
                  'images/profiles/' +
                  (personalInformation.image || 'default.jpg') +
                  '?rand=' + rand"
              >
              </v-img>
            </v-avatar>
            <a v-if="personalInformation.image" style="vertical-align: top; margin-left: 8px !important;"
               v-on:click="removeImage()"> X </a>
            <v-file-input
              :rules="fileRules"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="Upload photo (500x300px) **Optional"
              v-model="imageData.image"
              prepend-icon="mdi-camera"
              class="input"
              chips
              show-size
              @change="uploadImage()"
            ></v-file-input>
            <v-text-field
              v-model="personalInformation.fullName"
              label="Full Name"
              placeholder="John Doe"
            ></v-text-field>

            <v-text-field
              v-model="personalInformation.email"
              label="E-mail"
              disabled
            ></v-text-field>
            <v-text-field
              v-model="personalInformation.city"
              label="City"
              placeholder="Cartagena"
            ></v-text-field>
            <v-text-field
              v-model="personalInformation.state"
              label="State/Province/Region"
              placeholder="Murcia"
            ></v-text-field>
            <v-autocomplete
              v-model="personalInformation.country"
              :items="countries"
              label="Country"
              placeholder="Select..."
            ></v-autocomplete>
            <v-text-field
              v-model="personalInformation.phone"
              label="Phone Number"
            ></v-text-field>
            <v-file-input
              :rules="fileRules"
              accept="application/pdf"
              placeholder="Upload CV (PDF)"
              v-model="cvData.cv"
              show-size
              chips
            ></v-file-input>
            <div v-if="personalInformation.cv">
              Check your saved CV
              <a
                :href="VUE_APP_API_ENDPOINT + 'cvs/' + personalInformation.cv"
                target="blank"
                >here</a
              >
              <v-btn text class="text-gradient-half" :loading="cvEscoV2Loading" @click="processCvEscoV2">
                <div class="text-gradient-half">Extract suggestions from CV</div>
              </v-btn>
            </div>
            <div class="mt-2 d-flex flex-wrap align-center">
              <input
                ref="europassFileInput"
                type="file"
                accept=".xml,.json,.jsonld,application/xml,text/xml,application/json"
                class="d-none"
                @change="onEuropassFileSelected"
              >
              <v-btn text class="text-gradient-half" :loading="europassImportLoading" @click="triggerEuropassImport">
                <div class="text-gradient-half">Import Europass</div>
              </v-btn>
              <v-btn text class="text-gradient-half" :loading="europassExportLoading" @click="exportEuropass('json')">
                <div class="text-gradient-half">Export Europass (JSON)</div>
              </v-btn>
              <v-btn text class="text-gradient-half" :loading="europassExportLoading" @click="exportEuropass('xml')">
                <div class="text-gradient-half">Export Europass (XML)</div>
              </v-btn>
            </div>
          </v-card-text>
          <template v-if="personalInformation.cv || profileSectionIsDirty('personal')">
            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="personalInformation.cv" text class="text-gradient-half" @click="deleteCV"
                ><div class="text-gradient-half">Delete CV</div></v-btn
              >
              <v-btn
                v-if="profileSectionIsDirty('personal')"
                text
                @click="
                  uploadImage();
                  uploadCV();
                  updatePersonalInformation();
                "
              >
                <div class="text-gradient-half">Update</div>
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>
        <v-card class="card-form">
          <v-card-title
            class="primary white--text headline background-gradient"
          >
            <v-icon class="white-icon">mdi-pickaxe</v-icon>
            <span class="headline ml-3">Curriculum vitae: Job Experiences{{ profileSectionSuffix('experiences') }}</span>
          </v-card-title>
          <v-row class="pa-4">
            <v-col>
              <v-autocomplete
                v-model="experiencesSelectedAutocomplete"
                :loading="experiencesAutocompleteLoading"
                :items="experiencesAutocompleteSearch"
                :search-input.sync="experienceAutocompleteSearch"
                hide-no-data
                hide-details
                cache-items
                label="Search your experiences"
                chips
                clearable
                deletable-chips
                multiple
                solo
                flat
                ref="experienceSearch"
                class="profile-card-search"
                prepend-icon="mdi-magnify"
                item-text="label"
                item-value="label"
                @change="clearProfileCardSearch('experienceAutocompleteSearch')"
                @click.native="closeProfileSearchIfEmpty('experienceSearch', experienceAutocompleteSearch)"
              >
                <template v-slot:selection="{ item }">
                  <v-chip
                    small
                    close
                    class="ma-1 profile-search-chip"
                    :class="{ 'profile-search-chip--duplicate': profileSearchCollides(experiencesSelected, item) }"
                    :key="profileSearchLabel(item)"
                    @click:close="removeProfileSearchChip('experiencesSelectedAutocomplete', item)"
                  >
                    <span :class="{ 'profile-search-chip__struck': profileSearchCollides(experiencesSelected, item) }">{{ profileSearchLabel(item) }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <catalog-suggestion-item :item="item" />
                </template>
              </v-autocomplete>
              <ul v-if="experienceSearchCollisions.length" class="profile-search-errors">
                <li v-for="label in experienceSearchCollisions" :key="label">{{ label }} already added</li>
              </ul>
            </v-col>
          </v-row>
          <v-row class="pa-4">
            <v-col>
              <v-chip-group show-arrows column active-class="primary--text">
                <v-chip
                  :color="profileSearchCollides(experiencesSelectedAutocomplete, tag) ? 'warning' : 'primary'"
                  close
                  v-for="tag in experiencesSelected"
                  :key="tag"
                  @click:close="deleteExperience(tag)"
                >
                  {{ tag }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>

          <div v-if="cvEscoV2AppliedOccupationEntries.length" class="px-4 pb-2">
            <p class="sugestion-title mb-0">Job experiences suggested from CV (not saved yet)</p>
            <p class="sugestion-subtitle mb-3">*Push update to add checked sugestions</p>
            <div class="profile-suggestion-list">
            <div
              v-for="row in cvEscoV2AppliedOccupationEntries"
              :key="'occ' + row.evidenceId"
              class="profile-suggestion-item"
            >
              <v-chip
                color="secondary"
                outlined
                class="cv-suggestion-chip"
                @click="setCvEscoV2SuggestionChecked(row, !row.checked)"
              >
                <span
                  class="cv-suggestion-check"
                  role="checkbox"
                  :aria-checked="!!row.checked"
                >
                  <v-icon v-if="row.checked" class="cv-suggestion-check__mark">mdi-check</v-icon>
                </span>
                <span class="text-capitalize">{{ row.preferredLabel }}</span>
                <span class="ml-1 text-caption">· {{ cvEscoV2ConceptTypeBadge(row) }}</span>
              </v-chip>
              <div class="text-caption grey--text ml-1">CV job title — &quot;{{ row.evidence }}&quot;</div>
            </div>
            </div>
          </div>
          <template v-if="profileSectionIsDirty('experiences')">
            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="updateUserExperiences">
                <div class="text-gradient-half">Update</div>
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>
        <v-card class="card-form">
          <v-card-title
            class="primary white--text headline background-gradient"
          >
            <v-icon class="white-icon">mdi-briefcase</v-icon>
            <span class="headline ml-3">Curriculum vitae: Skills{{ profileSectionSuffix('skills') }}</span>
          </v-card-title>
          <v-row class="pa-4">
            <v-col>
              <v-autocomplete
                v-model="skillsSelectedAutocomplete"
                :loading="skillsAutocompleteLoading"
                :items="skillsAutocompleteSearch"
                :search-input.sync="skillAutocompleteSearch"
                hide-no-data
                hide-details
                cache-items
                label="Search your skills"
                chips
                clearable
                deletable-chips
                multiple
                solo
                flat
                ref="skillSearch"
                class="profile-card-search"
                prepend-icon="mdi-magnify"
                item-text="label"
                item-value="label"
                @change="clearProfileCardSearch('skillAutocompleteSearch')"
                @click.native="closeProfileSearchIfEmpty('skillSearch', skillAutocompleteSearch)"
              >
                <template v-slot:selection="{ item }">
                  <v-chip
                    small
                    close
                    class="ma-1 profile-search-chip"
                    :class="{ 'profile-search-chip--duplicate': profileSearchCollides(skillsSelected, item) }"
                    :key="profileSearchLabel(item)"
                    @click:close="removeProfileSearchChip('skillsSelectedAutocomplete', item)"
                  >
                    <span :class="{ 'profile-search-chip__struck': profileSearchCollides(skillsSelected, item) }">{{ profileSearchLabel(item) }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <catalog-suggestion-item :item="item" />
                </template>
              </v-autocomplete>
              <ul v-if="skillSearchCollisions.length" class="profile-search-errors">
                <li v-for="label in skillSearchCollisions" :key="label">{{ label }} already added</li>
              </ul>
            </v-col>
          </v-row>
          <v-row class="pa-4">
            <v-col>
              <v-chip-group show-arrows column active-class="primary--text">
                <v-chip
                  :color="profileSearchCollides(skillsSelectedAutocomplete, tag) ? 'warning' : 'primary'"
                  close
                  v-for="tag in skillsSelected"
                  :key="tag"
                  @click:close="deleteSkill(tag)"
                >
                  {{ tag }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
          <div v-if="cvEscoV2AppliedSkillEntries.length" class="px-4 pb-2">
            <p class="sugestion-title mb-0">Skills suggested from CV (not saved yet)</p>
            <p class="sugestion-subtitle mb-3">*Push update to add checked sugestions</p>
            
            <div class="profile-suggestion-list">
            <div
              v-for="row in cvEscoV2AppliedSkillEntries"
              :key="'sk' + row.evidenceId"
              class="profile-suggestion-item"
            >
              <v-chip
                color="secondary"
                outlined
                class="cv-suggestion-chip"
                @click="setCvEscoV2SuggestionChecked(row, !row.checked)"
              >
                <span
                  class="cv-suggestion-check"
                  role="checkbox"
                  :aria-checked="!!row.checked"
                >
                  <v-icon v-if="row.checked" class="cv-suggestion-check__mark">mdi-check</v-icon>
                </span>
                <span class="text-capitalize">{{ row.preferredLabel }}</span>
                <span class="ml-1 text-caption">· {{ cvEscoV2ConceptTypeBadge(row) }}</span>
              </v-chip>
              <div class="profile-suggestion-from grey--text">From: &quot;{{ row.evidence }}&quot;</div>
            </div>
            </div>
          </div>
          <template v-if="profileSectionIsDirty('skills')">
            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="updateUserSkills">
                <div class="text-gradient-half">Update</div>
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>

        <v-card class="card-form">
          <v-card-title
            class="primary white--text headline background-gradient"
          >
            <v-icon class="white-icon">mdi-briefcase</v-icon>
            <span class="headline ml-3">Curriculum vitae: Competences{{ profileSectionSuffix('competences') }}</span>
          </v-card-title>
          <v-row class="pa-4">
            <v-col>
              <v-autocomplete
                v-model="competencesSelectedAutocomplete"
                :loading="competencesAutocompleteLoading"
                :items="competencesAutocompleteSearch"
                :search-input.sync="competenceAutocompleteSearch"
                hide-no-data
                hide-details
                cache-items
                label="Search your competences"
                chips
                clearable
                deletable-chips
                multiple
                solo
                flat
                ref="competenceSearch"
                class="profile-card-search"
                prepend-icon="mdi-magnify"
                item-text="label"
                item-value="label"
                @change="clearProfileCardSearch('competenceAutocompleteSearch')"
                @click.native="closeProfileSearchIfEmpty('competenceSearch', competenceAutocompleteSearch)"
              >
                <template v-slot:selection="{ item }">
                  <v-chip
                    small
                    close
                    class="ma-1 profile-search-chip"
                    :class="{ 'profile-search-chip--duplicate': profileSearchCollides(competencesSelected, item) }"
                    :key="profileSearchLabel(item)"
                    @click:close="removeProfileSearchChip('competencesSelectedAutocomplete', item)"
                  >
                    <span :class="{ 'profile-search-chip__struck': profileSearchCollides(competencesSelected, item) }">{{ profileSearchLabel(item) }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <catalog-suggestion-item :item="item" />
                </template>
              </v-autocomplete>
              <ul v-if="competenceSearchCollisions.length" class="profile-search-errors">
                <li v-for="label in competenceSearchCollisions" :key="label">{{ label }} already added</li>
              </ul>
            </v-col>
          </v-row>
          <v-row class="pa-4">
            <v-col>
              <v-chip-group show-arrows column active-class="primary--text">
                <v-chip
                  :color="profileSearchCollides(competencesSelectedAutocomplete, tag) ? 'warning' : 'primary'"
                  close
                  v-for="tag in competencesSelected"
                  :key="tag"
                  @click:close="deleteCompetence(tag)"
                >
                  {{ tag }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
          <div v-if="cvEscoV2AppliedCompetenceEntries.length" class="px-4 pb-2">
            <p class="sugestion-title mb-0">Competences suggested from CV (not saved yet)</p>
            <p class="sugestion-subtitle mb-3">*Push update to add checked sugestions</p>
            <div class="profile-suggestion-list">
            <div
              v-for="row in cvEscoV2AppliedCompetenceEntries"
              :key="'cmp' + row.evidenceId"
              class="profile-suggestion-item"
            >
              <v-chip
                color="secondary"
                outlined
                class="cv-suggestion-chip"
                @click="setCvEscoV2SuggestionChecked(row, !row.checked)"
              >
                <span
                  class="cv-suggestion-check"
                  role="checkbox"
                  :aria-checked="!!row.checked"
                >
                  <v-icon v-if="row.checked" class="cv-suggestion-check__mark">mdi-check</v-icon>
                </span>
                <span class="text-capitalize">{{ row.preferredLabel }}</span>
                <span class="ml-1 text-caption">· {{ cvEscoV2ConceptTypeBadge(row) }}</span>
              </v-chip>
              <div class="profile-suggestion-from grey--text">From: &quot;{{ row.evidence }}&quot;</div>
            </div>
            </div>
          </div>
          <template v-if="profileSectionIsDirty('competences')">
            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="updateUserCompetences">
                <div class="text-gradient-half">Update</div>
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>

        <v-card class="card-form">
          <v-card-title
            class="primary white--text headline background-gradient"
          >
            <v-icon class="white-icon">mdi-school</v-icon>
            <span class="headline ml-3">Curriculum vitae: Education{{ profileSectionSuffix('education') }}</span>
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              elevation="0"
              @click="addEducation"
            >
              <v-icon class="white-icon"> mdi-plus </v-icon>
            </v-btn>
          </v-card-title>
          <v-expansion-panels v-model="openEducationPanels" multiple>
            <v-expansion-panel
              v-for="(education, index) in educationsSelected"
              :key="index"
            >
              <v-expansion-panel-header class="font-weight-medium">
                {{ education.name || 'New education' }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card-text class="pt-0">
                  <v-text-field
                    class="pl-5 pr-3"
                    v-model="educationsSelected[index].university"
                    label="University/Academy/School/Other (Eg: Politechnical University of Cartagena)"
                    required
                    :rules="requiredRules"
                  ></v-text-field>

                  <v-autocomplete
                    class="pl-5 pr-3"
                    clearable
                    v-model="educationsSelected[index].level"
                    label="Education level"
                    placeholder="Select your degree..."
                    :items="degrees"
                    required
                  ></v-autocomplete>
                  <v-text-field
                    class="pl-5 pr-3"
                    label="Education name (Eg: Telecommunications)"
                    v-model="educationsSelected[index].name"
                    required
                    :rules="requiredRules"
                  ></v-text-field>
                  <br />
                  <v-range-slider
                    class="pl-5 pr-3"
                    v-model="educationsSelected[index].startAndEndYear"
                    label="Start and end year"
                    hint="Select the start and end year"
                    max="2025"
                    min="1970"
                    step="1"
                    color="primary"
                    thumb-label="always"
                  ></v-range-slider>
                  <v-divider class="mt-4"></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      @click="
                        educationsSelected.splice(index, 1);
                        updateUserEducations();
                      "
                    >
                      <div class="text-gradient-half">Delete</div>
                    </v-btn>
                    <v-btn text @click="addEducation">
                      <div class="text-gradient-half">Add new</div>
                    </v-btn>
                    <v-btn v-if="profileSectionIsDirty('education')" color="primary" text @click="updateUserEducations">
                      <div class="text-gradient-half">Update</div>
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div v-if="cvEscoV2AppliedEducations.length" class="px-4 pt-4 pb-2">
            <p class="sugestion-title mb-0">Education suggested from CV (not saved yet)</p>
            <p class="sugestion-subtitle mb-3">*Push update to add checked sugestions</p>
            <div class="profile-suggestion-list">
            <div
              v-for="(row, index) in cvEscoV2AppliedEducations"
              :key="'edu-sug' + index"
              class="profile-suggestion-item"
            >
              <v-chip
                color="secondary"
                outlined
                class="cv-suggestion-chip"
                @click="setCvEscoV2EducationChecked(row, !row.checked)"
              >
                <span
                  class="cv-suggestion-check"
                  role="checkbox"
                  :aria-checked="!!row.checked"
                >
                  <v-icon v-if="row.checked" class="cv-suggestion-check__mark">mdi-check</v-icon>
                </span>
                <span>{{ row.name || 'Education' }}</span>
              </v-chip>
              <div class="text-caption grey--text ml-1">{{ cvEscoV2EducationSuggestionCaption(row) }}</div>
            </div>
            </div>
          </div>
          <template v-if="!educationsSelected.length || (cvEscoV2AppliedEducations.length && profileSectionIsDirty('education'))">
            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="!educationsSelected.length" text @click="addEducation">
                <div class="text-gradient-half">Add new</div>
              </v-btn>
              <v-btn v-if="profileSectionIsDirty('education')" color="primary" text @click="updateUserEducations">
                <div class="text-gradient-half">Update</div>
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>

        <v-card class="card-form">
          <v-card-title
            class="primary white--text headline background-gradient"
          >
            <v-icon class="white-icon">mdi-briefcase</v-icon>
            <span class="headline ml-3">Job Challenges{{ profileSectionSuffix('challenges') }}</span>
          </v-card-title>
          <v-row class="pa-4">
            <v-col>
              <v-autocomplete
                v-model="challengesSelectedAutocomplete"
                :loading="challengesAutocompleteLoading"
                :items="challengesAutocompleteSearch"
                :search-input.sync="challengeAutocompleteSearch"
                hide-no-data
                hide-details
                cache-items
                label="Search your job challenges"
                chips
                clearable
                deletable-chips
                multiple
                solo
                flat
                ref="challengeSearch"
                class="profile-card-search"
                prepend-icon="mdi-magnify"
                item-text="label"
                item-value="label"
                @change="clearProfileCardSearch('challengeAutocompleteSearch')"
                @click.native="closeProfileSearchIfEmpty('challengeSearch', challengeAutocompleteSearch)"
              >
                <template v-slot:selection="{ item }">
                  <v-chip
                    small
                    close
                    class="ma-1 profile-search-chip"
                    :class="{ 'profile-search-chip--duplicate': profileSearchCollides(challengesSelected, item) }"
                    :key="profileSearchLabel(item)"
                    @click:close="removeProfileSearchChip('challengesSelectedAutocomplete', item)"
                  >
                    <span :class="{ 'profile-search-chip__struck': profileSearchCollides(challengesSelected, item) }">{{ profileSearchLabel(item) }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <catalog-suggestion-item :item="item" />
                </template>
              </v-autocomplete>
              <ul v-if="challengeSearchCollisions.length" class="profile-search-errors">
                <li v-for="label in challengeSearchCollisions" :key="label">{{ label }} already added</li>
              </ul>
            </v-col>
          </v-row>
          <v-row class="pa-4">
            <v-col>
              <v-chip-group show-arrows column active-class="primary--text">
                <v-chip
                  :color="profileSearchCollides(challengesSelectedAutocomplete, tag) ? 'warning' : 'primary'"
                  close
                  v-for="tag in challengesSelected"
                  :key="tag"
                  @click:close="deleteChallenge(tag)"
                >
                  {{ tag }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
          <template v-if="profileSectionIsDirty('challenges')">
            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="updateUserChallenges">
                <div class="text-gradient-half">Update</div>
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="cvProcessOpen" max-width="560" persistent>
      <v-card>
        <v-card-title class="cv-review-dialog__title primary white--text headline background-gradient bold">Processing CV...</v-card-title>
        <v-card-text class="cv-review-dialog__body ">
          <p class="text-body-1 mb-2 mt-2 text-center">{{ cvProcessStatusLabel }}</p>
          <p class="text-body-2 mb-2 text-center">
            this operation may take more than a minute.. {{ cvProcessElapsedLabel }} / {{ cvProcessEstimateLabel }}
          </p>
          
        </v-card-text>
        <v-card-actions class="cv-review-dialog__actions">
          <v-spacer></v-spacer>
          <v-btn text @click="cancelCvProcess">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cvEscoV2ReviewOpen" max-width="960" scrollable persistent>
      <v-card v-if="cvEscoV2Draft && cvEscoV2Review">
        <v-card-title class="cv-review-dialog__title primary white--text headline background-gradient">{{ cvEscoV2ReviewTitle }}</v-card-title>
        <v-card-text class="cv-review-dialog__body">
          <p class="text-body-2 mb-4">
            {{ cvEscoV2ReviewIntro }}
          </p>

          <p class="subtitle-1 mb-2">Job experiences (ESCO occupations)</p>
          <div
            v-for="row in cvEscoV2JobEscoAutoRows"
            :key="'cv2jobescoauto' + row.evidenceId"
            class="mb-3 pa-3"
            style="border: 1px solid #e0e0e0; border-radius: 4px;"
          >
            <v-checkbox
              hide-details
              class="mt-0"
              :input-value="cvEscoV2Review.selectedAuto[row.evidenceId] !== false"
              @change="v => $set(cvEscoV2Review.selectedAuto, row.evidenceId, $event)"
            >
              <template v-slot:label>
                <div class="d-flex align-center flex-wrap">
                  <span class="text-body-1 text-capitalize mr-2">{{ row.preferredLabel }}</span>
                  <v-chip x-small outlined label class="mr-1">{{ cvEscoV2ConceptTypeBadge(row) }}</v-chip>
                  <v-chip v-if="row.relation" x-small outlined>{{ cvEscoV2RelationLabel(row.relation) }}</v-chip>
                </div>
              </template>
            </v-checkbox>
            <p class="text-caption mb-0 ml-8 grey--text">
              CV job title — &quot;{{ row.evidence }}&quot;
            </p>
          </div>
          <div
            v-for="row in cvEscoV2JobEscoReviewRows"
            :key="'cv2jobescorev' + row.evidenceId"
            class="mb-4 pa-3 cv-review-choice"
            :class="cvEscoV2MatchNeedsChoice(row.evidenceId) ? 'cv-review-choice--pending' : 'cv-review-choice--done'"
          >
            <p class="text-body-2 font-weight-medium mb-1 d-flex align-center">
              <v-icon
                class="mr-2"
                :class="cvEscoV2MatchNeedsChoice(row.evidenceId) ? 'cv-review-action-icon--pending' : 'cv-review-action-icon--done'"
              >mdi-gesture-tap</v-icon>
              CV job title: &quot;{{ row.evidence }}&quot;
            </p>
            <p class="text-caption mb-2">We found several possible matches. Select at least one option, 'None of these' to ignore:</p>
            <v-checkbox
              v-for="opt in row.options"
              :key="opt.uri"
              hide-details
              class="mt-0"
              :input-value="isCvEscoV2ReviewOptionChecked(row.evidenceId, opt.uri)"
              @change="toggleCvEscoV2ReviewOption(row.evidenceId, opt.uri, $event)"
            >
              <template v-slot:label>
                <div class="d-flex align-center flex-wrap">
                  <span class="text-capitalize mr-2">{{ opt.preferredLabel }}</span>
                  <v-chip x-small outlined label class="mr-1">{{ cvEscoV2ConceptTypeBadge(opt) }}</v-chip>
                  <v-chip x-small outlined>{{ cvEscoV2RelationLabel(opt.relation) }}</v-chip>
                </div>
              </template>
            </v-checkbox>
            <v-checkbox
              hide-details
              class="mt-0"
              label="None of these"
              :input-value="isCvEscoV2ReviewNoneChecked(row.evidenceId)"
              @change="toggleCvEscoV2ReviewNone(row.evidenceId, $event)"
            ></v-checkbox>
          </div>
          <p
            v-if="!cvEscoV2JobEscoAutoRows.length && !cvEscoV2JobEscoReviewRows.length"
            class="text-caption grey--text"
          >
            No ESCO occupation detected from job titles
          </p>

          <v-divider class="my-4"></v-divider>
          <p class="subtitle-1 mb-2">Detected ESCO tags</p>

          <template v-for="section in cvEscoV2AutoEscoSections">
            <div v-if="section.rows.length" :key="'auto-sec' + section.key">
            <p class="subtitle-2 mt-3 mb-2">{{ section.title }}</p>
            <div
              v-for="row in section.rows"
              :key="'cv2auto' + row.evidenceId"
              class="mb-3 pa-3"
              style="border: 1px solid #e0e0e0; border-radius: 4px;"
            >
              <v-checkbox
                hide-details
                class="mt-0"
                :input-value="cvEscoV2Review.selectedAuto[row.evidenceId] !== false"
                @change="v => $set(cvEscoV2Review.selectedAuto, row.evidenceId, $event)"
              >
                <template v-slot:label>
                  <div class="d-flex align-center flex-wrap">
                    <span class="text-body-1 text-capitalize mr-2">{{ row.preferredLabel }}</span>
                    <v-chip x-small outlined label class="mr-1">ESCO {{ cvEscoV2ConceptTypeBadge(row) }}</v-chip>
                    <v-chip v-if="row.relation" x-small outlined>{{ cvEscoV2RelationLabel(row.relation) }}</v-chip>
                  </div>
                </template>
              </v-checkbox>
              <p class="text-caption mb-0 ml-8 grey--text">
                {{ cvEscoV2EvidenceSourceLabel(row) }} — &quot;{{ row.evidence }}&quot;
              </p>
            </div>
            </div>
          </template>
          <p v-if="!(cvEscoV2Draft.esco.autoSelected && cvEscoV2Draft.esco.autoSelected.length)" class="text-caption grey--text">
            No preselected suggestion
          </p>

          <template v-for="section in cvEscoV2ReviewEscoSections">
            <div v-if="section.rows.length" :key="'rev-sec' + section.key">
            <p class="subtitle-2 mt-4 mb-2">{{ section.title }} (review)</p>
            <div
              v-for="row in section.rows"
              :key="'cv2rev' + row.evidenceId"
              class="mb-4 pa-3 cv-review-choice"
              :class="cvEscoV2MatchNeedsChoice(row.evidenceId) ? 'cv-review-choice--pending' : 'cv-review-choice--done'"
            >
              <p class="text-body-2 font-weight-medium mb-1 d-flex align-center">
                <v-icon
                  class="mr-2"
                  :class="cvEscoV2MatchNeedsChoice(row.evidenceId) ? 'cv-review-action-icon--pending' : 'cv-review-action-icon--done'"
                >mdi-gesture-tap</v-icon>
                {{ cvEscoV2EvidenceSourceLabel(row) }}: &quot;{{ row.evidence }}&quot;
              </p>
              <p class="text-caption mb-2">We found several possible matches. Select at least one option, 'None of these' to ignore:</p>
              <v-checkbox
                v-for="opt in row.options"
                :key="opt.uri"
                hide-details
                class="mt-0"
                :input-value="isCvEscoV2ReviewOptionChecked(row.evidenceId, opt.uri)"
                @change="toggleCvEscoV2ReviewOption(row.evidenceId, opt.uri, $event)"
              >
                <template v-slot:label>
                  <div class="d-flex align-center flex-wrap">
                    <span class="text-capitalize mr-2">{{ opt.preferredLabel }}</span>
                    <v-chip x-small outlined label class="mr-1">{{ cvEscoV2ConceptTypeBadge(opt) }}</v-chip>
                    <v-chip x-small outlined>{{ cvEscoV2RelationLabel(opt.relation) }}</v-chip>
                  </div>
                </template>
              </v-checkbox>
              <v-checkbox
                hide-details
                class="mt-0"
                label="None of these"
                :input-value="isCvEscoV2ReviewNoneChecked(row.evidenceId)"
                @change="toggleCvEscoV2ReviewNone(row.evidenceId, $event)"
              ></v-checkbox>
            </div>
            </div>
          </template>

          <v-divider class="my-4"></v-divider>
          <p class="subtitle-1 mb-2">Education detected</p>
          <div
            v-for="(edu, index) in cvEscoV2Draft.education"
            :key="'cv2edu' + index"
            class="mb-2"
            :class="{ 'pa-3 cv-review-choice cv-review-choice--pending': cvEscoV2EducationNeedsInput(index) }"
          >
            <v-checkbox
              hide-details
              class="mt-0"
              :input-value="isCvEscoV2EducationSelected(index)"
              @change="toggleCvEscoV2Education(index, $event)"
            >
              <template v-slot:label>
                <div>
                  <div class="text-body-1">{{ edu.title || 'Education' }}</div>
                  <div v-if="edu.university" class="text-caption grey--text">{{ edu.university }}</div>
                  <div v-if="edu.start || edu.end" class="text-caption grey--text">
                    {{ edu.start }}{{ edu.end ? ' — ' + edu.end : '' }}
                  </div>
                </div>
              </template>
            </v-checkbox>
            <div v-if="isCvEscoV2EducationSelected(index)" class="ml-8 mr-2 mb-3">
              <div class="d-flex align-center mt-2">
                <v-icon v-if="cvEscoV2EducationFieldNeedsInput(index, 'level')" class="cv-review-action-icon--pending mr-2">mdi-gesture-tap</v-icon>
                <v-autocomplete
                  v-model="edu.level"
                  :items="degrees"
                  label="Education level *"
                  placeholder="Select your degree..."
                  hide-details
                  dense
                  outlined
                  class="flex-grow-1"
                ></v-autocomplete>
              </div>
              <div v-if="cvEscoV2EducationGap(index, 'name')" class="d-flex align-center mt-2">
                <v-icon v-if="cvEscoV2EducationFieldNeedsInput(index, 'name')" class="cv-review-action-icon--pending mr-2">mdi-gesture-tap</v-icon>
                <v-text-field
                  v-model="edu.title"
                  label="Education name *"
                  hide-details
                  dense
                  outlined
                  class="flex-grow-1"
                ></v-text-field>
              </div>
              <div v-if="cvEscoV2EducationGap(index, 'university')" class="d-flex align-center mt-2">
                <v-icon v-if="cvEscoV2EducationFieldNeedsInput(index, 'university')" class="cv-review-action-icon--pending mr-2">mdi-gesture-tap</v-icon>
                <v-text-field
                  v-model="edu.university"
                  label="University / school *"
                  hide-details
                  dense
                  outlined
                  class="flex-grow-1"
                ></v-text-field>
              </div>
              <div v-if="cvEscoV2EducationGap(index, 'start')" class="d-flex align-center mt-2">
                <v-icon v-if="cvEscoV2EducationFieldNeedsInput(index, 'start')" class="cv-review-action-icon--pending mr-2">mdi-gesture-tap</v-icon>
                <v-text-field
                  v-model="edu.start"
                  label="Start year *"
                  type="number"
                  min="1970"
                  max="2026"
                  hide-details
                  dense
                  outlined
                  class="flex-grow-1"
                ></v-text-field>
              </div>
              <div v-if="cvEscoV2EducationGap(index, 'end')" class="d-flex align-center mt-2">
                <v-icon v-if="cvEscoV2EducationFieldNeedsInput(index, 'end')" class="cv-review-action-icon--pending mr-2">mdi-gesture-tap</v-icon>
                <v-text-field
                  v-model="edu.end"
                  label="End year *"
                  type="number"
                  min="1970"
                  max="2026"
                  hide-details
                  dense
                  outlined
                  class="flex-grow-1"
                ></v-text-field>
              </div>
            </div>
          </div>
          <p v-if="!(cvEscoV2Draft.education && cvEscoV2Draft.education.length)" class="text-caption grey--text">No education detected</p>

          <v-divider class="my-4"></v-divider>
          <p class="subtitle-2 mb-2 grey--text text--darken-1">Items with no ESCO match</p>
          <div
            v-for="row in cvEscoV2Draft.esco.noMatch"
            :key="'cv2nom' + row.evidenceId"
            class="text-caption grey--text mb-1"
          >
            No ESCO match for: &quot;{{ row.evidence }}&quot;
          </div>
          <p v-if="!(cvEscoV2Draft.esco.noMatch && cvEscoV2Draft.esco.noMatch.length)" class="text-caption grey--text">
            None
          </p>
        </v-card-text>
        <v-card-actions class="cv-review-dialog__actions pt-2 pb-2">
          <div v-if="cvEscoV2PendingOptionCount" class="d-flex align-center">
            <v-icon class="cv-review-action-icon--pending mr-2">mdi-gesture-tap</v-icon>
            <span class="cv-review-pending-note">* {{ cvEscoV2PendingOptionCount }} options left, complete all options before "Apply to form"</span>
          </div>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelCvEscoV2Review">Cancel</v-btn>
          <v-btn
            text
            :disabled="!cvEscoV2ReviewComplete"
            @click="completeCvEscoV2Review"
          >
            <div class="text-gradient-half">Apply to form</div>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar_show" :color="snackbar_color" top>
      <v-icon>{{ snackbar_icon }}</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import CatalogSuggestionItem from '@/components/CatalogSuggestionItem.vue'
const cvEscoV2ReviewLib = require('../../../lib/cv-esco-v2-review')
const cvEscoV2ApplyLib = require('../../../lib/cv-esco-v2-apply')
const { catalogSuggestions, escoAutocompleteFetchInit } = require('../../../lib/catalog-autocomplete')

export default {
  components: { CatalogSuggestionItem },
  data: () => ({
    // Personal information
    personalInformation: {
      user_id: null,
      fullName: null,
      email: null,
      city: null,
      state: null,
      country: null,
      phone: null,
      image: null,
      cv: null,
    },

    imageData: {
      image: null,
    },
    cvData: {
      cv: null,
    },
    countries: [],
    fileRules: [
      (value) =>
        !value || value.size < 2000000 || "File size should be less than 2 MB!",
    ],
    requiredRules: [(v) => !!v || "This field is required"],

    formHasErrors: false,
    degrees: cvEscoV2ReviewLib.EDUCATION_LEVELS,
    modal: false,
    // Skills
    skillsSelected: null, // Skills saved by the user
    skillsAutocompleteLoading: false, // Loading animation autocomplete
    skillsAutocompleteSearch: [], // Results of the skills search autocomplete
    skillAutocompleteSearch: null, // Autocomplete search field
    skillsSelectedAutocomplete: [], // Autocomplete skills selected
    // Competences
    competencesSelected: null, // Competences saved by the user
    competencesAutocompleteLoading: false, // Loading animation autocomplete
    competencesAutocompleteSearch: [], // Results of the competences search autocomplete
    competenceAutocompleteSearch: null, // Autocomplete search field
    competencesSelectedAutocomplete: [], // Autocomplete competences selected
    // Experiences
    experiencesSelected: null, // Experiences saved by the user
    experiencesAutocompleteLoading: false, // Loading animation autocomplete
    experiencesAutocompleteSearch: [], // Results of the experiences search autocomplete
    experienceAutocompleteSearch: null, // Autocomplete search field
    experiencesSelectedAutocomplete: [], // Autocomplete experiences selected
    // Challenges
    challengesSelected: null, // Challenges saved by the user
    challengesAutocompleteLoading: false, // Loading animation autocomplete
    challengesAutocompleteSearch: [], // Results of the challenges search autocomplete
    challengeAutocompleteSearch: null, // Autocomplete search field
    challengesSelectedAutocomplete: [], // Autocomplete challenges selected
    // Educations
    educationsSelected: [],
    openEducationPanels: [],
    savedProfileAreas: null,
    profileSectionStatus: {
      personal: '',
      experiences: '',
      skills: '',
      competences: '',
      education: '',
      challenges: '',
    },
    // Snackbar
    snackbar_show: false,
    snackbar_color: null,
    snackbar_text: null,
    snackbar_icon: null,
    cvEscoV2Loading: false,
    cvEscoV2DraftSource: 'pdf',
    europassImportLoading: false,
    europassExportLoading: false,
    cvProcessOpen: false,
    cvProcessPhase: 'reading',
    cvProcessDone: 0,
    cvProcessTotal: 0,
    cvProcessStartedAt: 0,
    cvProcessNow: 0,
    cvProcessSearchMs: [],
    cvEscoV2Draft: null,
    cvEscoV2ReviewOpen: false,
    cvEscoV2Review: null,
    cvEscoV2ReviewedDraft: null,
    cvEscoV2AppliedJobs: [],
    cvEscoV2AppliedConcepts: [],
    cvEscoV2AppliedEscoFlat: [],
    cvEscoV2AppliedEducations: [],
    // env
    VUE_APP_API_ENDPOINT: process.env.VUE_APP_API_ENDPOINT,
    rand: new Date()
  }),
  watch: {
    skillAutocompleteSearch(name) {
      this.onProfileCardSearchInput('skillSearch', name, 'searchSkillsByName')
    },
    competenceAutocompleteSearch(name) {
      this.onProfileCardSearchInput('competenceSearch', name, 'searchCompetencesByName')
    },
    experienceAutocompleteSearch(name) {
      this.onProfileCardSearchInput('experienceSearch', name, 'searchExperiencesByName')
    },
    challengeAutocompleteSearch(name) {
      this.onProfileCardSearchInput('challengeSearch', name, 'searchChallengesByName')
    },
    educationsSelected() {
      this.openEducationPanels = (this.educationsSelected || []).map((_, index) => index)
    },
  },
  async created() {
    try {
      await this.getData();
      await this.getCountries();
    } catch (error) {
      if (error.message.includes("Authentication failed")) {
        this.$router.push("/auth-error");
      }
    }
  },
  beforeDestroy() {
    const timers = this._profileSectionTimers || {}
    Object.keys(timers).forEach((key) => clearTimeout(timers[key]))
    this.stopCvProcessClock()
    if (this._cvProcessAbort) this._cvProcessAbort.abort()
  },

  computed: {
    cvEscoV2ReviewComplete() {
      return cvEscoV2ReviewLib.isReviewComplete(this.cvEscoV2Draft, this.cvEscoV2Review)
    },
    cvEscoV2ReviewTitle() {
      return this.cvEscoV2DraftSource === 'europass'
        ? 'Review data detected from Europass'
        : 'Review data detected from the CV'
    },
    cvEscoV2ReviewIntro() {
      return this.cvEscoV2DraftSource === 'europass'
        ? 'We found structured information in your Europass file. Review the suggestions before applying them to the form. Nothing is saved until you confirm and update.'
        : 'We found information in your CV. Review the suggestions before applying them to the form.'
    },
    cvProcessElapsedLabel() {
      return this.formatCvProcessDuration(this.cvProcessNow - this.cvProcessStartedAt)
    },
    cvProcessEstimateLabel() {
      const samples = this.cvProcessSearchMs
      if (!samples.length) return '—'
      const average = samples.reduce((sum, ms) => sum + ms, 0) / samples.length
      const pending = Math.max(0, this.cvProcessTotal - this.cvProcessDone)
      const elapsed = Math.max(0, this.cvProcessNow - this.cvProcessStartedAt)
      return this.formatCvProcessDuration(elapsed + average * pending)
    },
    cvProcessStatusLabel() {
      if (this.cvProcessPhase === 'searching') {
        return 'Searching ESCO matches [ ' + this.cvProcessDone + '/' + this.cvProcessTotal + ' ]'
      }
      return this.cvEscoV2DraftSource === 'europass' ? 'Reading Europass...' : 'Reading PDF...'
    },
    cvEscoV2PendingOptionCount() {
      const needs = (this.cvEscoV2Draft && this.cvEscoV2Draft.esco && this.cvEscoV2Draft.esco.needsReview) || []
      let count = needs.filter((row) => row && row.evidenceId && this.cvEscoV2MatchNeedsChoice(row.evidenceId)).length
      const educations = (this.cvEscoV2Draft && this.cvEscoV2Draft.education) || []
      const fields = ['level', 'name', 'university', 'start', 'end']
      educations.forEach((_, index) => {
        if (!this.isCvEscoV2EducationSelected(index)) return
        fields.forEach((field) => {
          if (this.cvEscoV2EducationFieldNeedsInput(index, field)) count += 1
        })
      })
      return count
    },
    cvEscoV2AutoEscoSections() {
      return this.cvEscoV2EscoSectionsFor((this.cvEscoV2Draft && this.cvEscoV2Draft.esco && this.cvEscoV2Draft.esco.autoSelected) || [])
    },
    cvEscoV2ReviewEscoSections() {
      return this.cvEscoV2EscoSectionsFor((this.cvEscoV2Draft && this.cvEscoV2Draft.esco && this.cvEscoV2Draft.esco.needsReview) || [])
    },
    cvEscoV2AppliedSkillEntries() {
      return this.cvEscoV2AppliedEscoFlatByFormBucket('skill')
    },
    cvEscoV2AppliedCompetenceEntries() {
      return this.cvEscoV2AppliedEscoFlatByFormBucket('competence')
    },
    cvEscoV2AppliedOccupationEntries() {
      return this.cvEscoV2AppliedEscoFlatByFormBucket('job')
        .filter((row) => !cvEscoV2ReviewLib.isIscoUri(row && row.uri))
    },
    cvEscoV2JobEscoAutoRows() {
      return this.cvEscoV2EscoRowsBySource('job', 'autoSelected')
        .filter((row) => !cvEscoV2ReviewLib.isIscoUri(row && row.uri))
    },
    cvEscoV2JobEscoReviewRows() {
      return this.cvEscoV2EscoRowsBySource('job', 'needsReview').map((row) => Object.assign({}, row, {
        options: (row.options || []).filter((opt) => !cvEscoV2ReviewLib.isIscoUri(opt && opt.uri))
      })).filter((row) => row.options.length)
    },
    experienceSearchCollisions() {
      return this.profileSearchCollisions(this.experiencesSelected, this.experiencesSelectedAutocomplete)
    },
    skillSearchCollisions() {
      return this.profileSearchCollisions(this.skillsSelected, this.skillsSelectedAutocomplete)
    },
    competenceSearchCollisions() {
      return this.profileSearchCollisions(this.competencesSelected, this.competencesSelectedAutocomplete)
    },
    challengeSearchCollisions() {
      return this.profileSearchCollisions(this.challengesSelected, this.challengesSelectedAutocomplete)
    }
  },

  methods: {
    profileSectionSuffix(key) {
      const status = this.profileSectionStatus[key]
      if (status === 'updating') return ' - Updating...'
      if (status === 'updated') return ' - Updated!'
      if (this.profileSectionIsDirty(key)) return ' - Modified'
      return ''
    },
    profileSectionIsDirty(key) {
      if (!this.savedProfileAreas) return false
      if (key === 'personal') return this.personalAreaKey() !== this.savedProfileAreas.personal
      if (key === 'experiences') return this.tagAreaDirty('experiences', this.experiencesSelected, this.experiencesSelectedAutocomplete, 'job')
      if (key === 'skills') return this.tagAreaDirty('skills', this.skillsSelected, this.skillsSelectedAutocomplete, 'skill')
      if (key === 'competences') return this.tagAreaDirty('competences', this.competencesSelected, this.competencesSelectedAutocomplete, 'competence')
      if (key === 'challenges') return this.tagAreaDirty('challenges', this.challengesSelected, this.challengesSelectedAutocomplete, '')
      if (key === 'education') {
        if (this.educationAreaKey(this.educationsSelected) !== this.savedProfileAreas.educations) return true
        return (this.cvEscoV2AppliedEducations || []).some((row) => row && row.checked)
      }
      return false
    },
    personalAreaKey() {
      const info = this.personalInformation || {}
      const cvName = this.cvData && this.cvData.cv ? this.cvData.cv.name : ''
      const imageName = this.imageData && this.imageData.image ? this.imageData.image.name : ''
      return [info.fullName, info.city, info.state, info.country, info.phone, cvName, imageName]
        .map((value) => String(value == null ? '' : value).trim())
        .join('\n')
    },
    tagsAreaKey(list) {
      return (list || []).map((item) => this.profileSearchLabel(item)).join('\n')
    },
    educationAreaKey(list) {
      return (list || []).map((row) => [
        String((row && row.name) || '').trim(),
        String((row && row.university) || '').trim(),
        String((row && row.level) || '').trim(),
        row && row.startAndEndYear ? row.startAndEndYear[0] : '',
        row && row.startAndEndYear ? row.startAndEndYear[1] : ''
      ].join('\t')).join('\n')
    },
    tagAreaDirty(savedKey, current, pending, bucket) {
      if (this.tagsAreaKey(current) !== this.savedProfileAreas[savedKey]) return true
      if ((pending || []).length) return true
      if (bucket && this.cvEscoV2CheckedCatalogEntries(bucket).length) return true
      return false
    },
    captureSavedProfileAreas() {
      this.savedProfileAreas = {
        personal: this.personalAreaKey(),
        experiences: this.tagsAreaKey(this.experiencesSelected),
        skills: this.tagsAreaKey(this.skillsSelected),
        competences: this.tagsAreaKey(this.competencesSelected),
        challenges: this.tagsAreaKey(this.challengesSelected),
        educations: this.educationAreaKey(this.educationsSelected)
      }
    },
    markProfileSectionUpdating(key) {
      if (!this._profileSectionTimers) this._profileSectionTimers = {}
      if (this._profileSectionTimers[key]) clearTimeout(this._profileSectionTimers[key])
      this.$set(this.profileSectionStatus, key, 'updating')
    },
    markProfileSectionUpdated(key) {
      if (!this._profileSectionTimers) this._profileSectionTimers = {}
      if (this._profileSectionTimers[key]) clearTimeout(this._profileSectionTimers[key])
      this.$set(this.profileSectionStatus, key, 'updated')
      this._profileSectionTimers[key] = setTimeout(() => {
        this.$set(this.profileSectionStatus, key, '')
      }, 1500)
    },
    clearProfileSectionStatus(key) {
      if (this._profileSectionTimers && this._profileSectionTimers[key]) {
        clearTimeout(this._profileSectionTimers[key])
      }
      this.$set(this.profileSectionStatus, key, '')
    },
    profileSearchLabel(entry) {
      if (entry && typeof entry === 'object') {
        return String(entry.label || entry.name || '').trim()
      }
      return String(entry || '').trim()
    },
    profileSearchCollides(saved, item) {
      const wanted = this.profileSearchLabel(item).toLowerCase()
      if (!wanted) return false
      return (saved || []).some((tag) => this.profileSearchLabel(tag).toLowerCase() === wanted)
    },
    profileSearchCollisions(saved, pending) {
      const seen = new Set()
      const out = []
      for (const entry of pending || []) {
        const label = this.profileSearchLabel(entry)
        const key = label.toLowerCase()
        if (!key || seen.has(key)) continue
        if (this.profileSearchCollides(saved, label)) {
          seen.add(key)
          out.push(label)
        }
      }
      return out
    },
    removeProfileSearchChip(listName, item) {
      const label = this.profileSearchLabel(item)
      this[listName] = (this[listName] || []).filter((entry) => this.profileSearchLabel(entry) !== label)
    },
    clearProfileCardSearch(field) {
      const wipe = () => {
        this[field] = ''
      }
      wipe()
      this.$nextTick(() => {
        wipe()
        this.$nextTick(wipe)
      })
    },
    closeProfileSearchMenu(refName) {
      const close = () => {
        const field = this.$refs[refName]
        if (field) field.isMenuActive = false
      }
      close()
      this.$nextTick(() => {
        close()
        this.$nextTick(close)
      })
    },
    closeProfileSearchIfEmpty(refName, value) {
      if (String(value || '').trim()) return
      this.closeProfileSearchMenu(refName)
    },
    onProfileCardSearchInput(refName, name, searchMethod) {
      const text = String(name || '').trim()
      if (!text) {
        this.closeProfileSearchMenu(refName)
        return
      }
      if (name !== this.select) this[searchMethod](name)
    },
    profileSearchStillMatches(field, name) {
      return String(this[field] || '').trim() === String(name || '').trim()
    },
    async getData() {
      let response = await fetch(
        process.env.VUE_APP_API_ENDPOINT + "v2/people/user-profile/",
        {
          headers: {
            "Auth-Token": this.$cookie.get("jwt_token"),
          },
        }
      );
      response = await response.json();
      if (response.success) {
        this.personalInformation.user_id =
          response.result.personalInformation.user_id;
        console;
        this.personalInformation.fullName =
          response.result.personalInformation.full_name;
        this.personalInformation.email =
          response.result.personalInformation.email;
        this.personalInformation.city =
          response.result.personalInformation.city;
        this.personalInformation.state =
          response.result.personalInformation.state;
        this.personalInformation.country =
          response.result.personalInformation.country;
        this.personalInformation.phone =
          response.result.personalInformation.phone;
        this.personalInformation.image =
          response.result.personalInformation.image;
        this.personalInformation.cv = response.result.personalInformation.cv;
        this.skillsSelected = response.result.skills;
        this.competencesSelected = response.result.competences;
        this.challengesSelected = response.result.challenges;
        this.experiencesSelected = response.result.experiences;
        this.educationsSelected = response.result.educations;
        this.captureSavedProfileAreas()
        this.$emit('missingProfile', response.result.missingProfile)
      } else {
        throw new Error(response.message);
      }
    },
    async getCountries() {
      let response = await fetch(
        process.env.VUE_APP_API_ENDPOINT + "common/countries/",
        {
          headers: {
            "Auth-Token": this.$cookie.get("jwt_token"),
          },
        }
      );
      response = await response.json();
      this.countries = response.result;
    },
    async updatePersonalInformation() {
      this.markProfileSectionUpdating('personal');
      let response;
      let saved = false;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT +
            "people/user-profile/personal-information",
          {
            method: "PUT",
            body: JSON.stringify(this.personalInformation),
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
          }
        );
        response = await response.json();
        if (response.success) {
          saved = true;
          // Info message
          this.snackbar_color = "success";
          this.snackbar_text = "Personal information updated";
          this.snackbar_icon = "mdi-check";
          // Display the result as a short message
          this.snackbar_show = true;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        // Error message
        this.snackbar_color = "error";
        this.snackbar_text = response.message;
        this.snackbar_icon = "mdi-alert-circle";
      }
      // Display the result as a short message
      this.snackbar_show = true;
      await this.getData();
      if (saved) this.markProfileSectionUpdated('personal');
      else this.clearProfileSectionStatus('personal');
    },
    async searchSkillsByName(name) {
      let response;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT + "v2/common/search-skills-by-name",
          escoAutocompleteFetchInit(this, { name })
        );
        response = await response.json();
      } catch (error) {
        console.log(error.message);
      }
      this.skillsAutocompleteLoading = false;
      if (!this.profileSearchStillMatches('skillAutocompleteSearch', name)) return
      this.skillsAutocompleteSearch = catalogSuggestions(response.result);
    },
    async searchCompetencesByName(name) {
      let response;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT +
            "v2/common/search-competences-by-name",
          escoAutocompleteFetchInit(this, { name })
        );
        response = await response.json();
      } catch (error) {
        console.log(error.message);
      }
      this.competencesAutocompleteLoading = false;
      if (!this.profileSearchStillMatches('competenceAutocompleteSearch', name)) return
      this.competencesAutocompleteSearch = catalogSuggestions(response.result);
    },
    async searchExperiencesByName(name) {
      let response;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT +
            "v2/common/search-experiences-by-name",
          escoAutocompleteFetchInit(this, { name })
        );
        response = await response.json();
      } catch (error) {
        console.log(error.message);
      }
      this.experiencesAutocompleteLoading = false;
      if (!this.profileSearchStillMatches('experienceAutocompleteSearch', name)) return
      this.experiencesAutocompleteSearch = catalogSuggestions(response.result);
    },
    async searchChallengesByName(name) {
      let response;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT + "v2/common/search-challenges-by-name",
          escoAutocompleteFetchInit(this, { name })
        );
        response = await response.json();
      } catch (error) {
        console.log(error.message);
      }
      this.challengesAutocompleteLoading = false;
      if (!this.profileSearchStillMatches('challengeAutocompleteSearch', name)) return
      this.challengesAutocompleteSearch = catalogSuggestions(response.result);
    },
    addEducation() {
      this.educationsSelected.push({
        name: '',
        university: '',
        level: null,
        startAndEndYear: [2004, 2014],
      })
    },
    async updateUserEducations() {
      this.markProfileSectionUpdating('education');
      const educations = cvEscoV2ApplyLib.educationsForSave(
        this.educationsSelected,
        this.cvEscoV2AppliedEducations
      );
      let response;
      let saved = false;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT +
            "people/user-profile/user-educations",
          {
            method: "PUT",
            body: JSON.stringify({ educations: educations }),
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
          }
        );
        response = await response.json();
        if (response.success) {
          saved = true;
          this.snackbar_color = "success";
          this.snackbar_text = "Educations updated";
          this.snackbar_icon = "mdi-check";
          this.snackbar_show = true;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        this.snackbar_color = "error";
        this.snackbar_text = (response && response.message) || error.message;
        this.snackbar_icon = "mdi-alert-circle";
      }
      this.snackbar_show = true;
      if (!saved) {
        this.clearProfileSectionStatus('education');
        return;
      }
      this.cvEscoV2AppliedEducations = [];
      await this.getData();
      this.markProfileSectionUpdated('education');
    },
    async updateUserSkills() {
      this.markProfileSectionUpdating('skills');
      const newSkills = this.cvEscoV2TagsForUpdate(
        "skill",
        this.skillsSelected,
        this.skillsSelectedAutocomplete
      );
      let response;
      let saved = false;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT + "v2/people/user-profile/user-skills",
          {
            method: "PUT",
            body: JSON.stringify({ skills: newSkills }),
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
          }
        );
        response = await response.json();
        if (response.success) {
          saved = true;
          this.snackbar_color = "success";
          this.snackbar_text = "Skills updated";
          this.snackbar_icon = "mdi-check";
          this.snackbar_show = true;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        this.snackbar_color = "error";
        this.snackbar_text = (response && response.message) || error.message;
        this.snackbar_icon = "mdi-alert-circle";
      }
      this.snackbar_show = true;
      if (!saved) {
        this.clearProfileSectionStatus('skills');
        return;
      }
      this.skillsSelectedAutocomplete = [];
      this.clearCvEscoV2Suggestions("skill");
      await this.getData();
      this.markProfileSectionUpdated('skills');
    },
    deleteSkill(name) {
      for (const i in this.skillsSelected) {
        if (this.skillsSelected[i] === name) {
          this.skillsSelected.splice(i, 1);
        }
      }
    },
    deleteExperience(name) {
      for (const i in this.experiencesSelected) {
        if (this.experiencesSelected[i] === name) {
          this.experiencesSelected.splice(i, 1);
        }
      }
    },
    async updateUserCompetences() {
      this.markProfileSectionUpdating('competences');
      const newCompetences = this.cvEscoV2TagsForUpdate(
        "competence",
        this.competencesSelected,
        this.competencesSelectedAutocomplete
      );
      let response;
      let saved = false;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT +
            "v2/people/user-profile/user-competences",
          {
            method: "PUT",
            body: JSON.stringify({ skills: newCompetences }),
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
          }
        );
        response = await response.json();
        if (response.success) {
          saved = true;
          this.snackbar_color = "success";
          this.snackbar_text = "Competences updated";
          this.snackbar_icon = "mdi-check";
          this.snackbar_show = true;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        this.snackbar_color = "error";
        this.snackbar_text = (response && response.message) || error.message;
        this.snackbar_icon = "mdi-alert-circle";
      }
      this.snackbar_show = true;
      if (!saved) {
        this.clearProfileSectionStatus('competences');
        return;
      }
      this.competencesSelectedAutocomplete = [];
      this.clearCvEscoV2Suggestions("competence");
      await this.getData();
      this.markProfileSectionUpdated('competences');
    },
    deleteCompetence(name) {
      for (const i in this.competencesSelected) {
        if (this.competencesSelected[i] === name) {
          this.competencesSelected.splice(i, 1);
        }
      }
    },
    async updateUserChallenges() {
      this.markProfileSectionUpdating('challenges');
      // Join the autocomplete challenges with the saved challenges and remove duplicates
      const newChallenges = this.challengesSelectedAutocomplete.concat(
        this.challengesSelected.filter(
          (item) => this.challengesSelectedAutocomplete.indexOf(item) < 0
        )
      );
      let response;
      let saved = false;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT +
            "v2/people/user-profile/user-challenges",
          {
            method: "PUT",
            body: JSON.stringify({ challenges: newChallenges }),
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
          }
        );
        response = await response.json();
        if (response.success) {
          saved = true;
          // Info message
          this.snackbar_color = "success";
          this.snackbar_text = "Challenges updated";
          this.snackbar_icon = "mdi-check";
          // Display the result as a short message
          this.snackbar_show = true;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        // Error message
        this.snackbar_color = "error";
        this.snackbar_text = response.message;
        this.snackbar_icon = "mdi-alert-circle";
      }
      // Display the result as a short message
      this.snackbar_show = true;
      if (!saved) {
        this.clearProfileSectionStatus('challenges');
        return;
      }
      this.challengesSelectedAutocomplete = [];
      await this.getData();
      this.markProfileSectionUpdated('challenges');
    },

    async removeImage(){
      this.imageData.image = null
      this.uploadImage()
    },

    async uploadImage() {

      let response;

      try {
        let formData = new FormData();
        if (this.imageData.image != null) {
          formData.append(
            "image",
            this.imageData.image,
            this.imageData.image.name
          );
        }
        formData.append("userId", this.personalInformation.user_id);
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT + "common/upload-profile-image",
          {
            method: "POST",
            body: formData,
            headers: {
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
          }
        )
        response = await response.json()
        // console.log(response)
        // console.log(JSON.stringify(response))
        if (response.success) {
          this.snackbar_color = "success";
          this.snackbar_text = "Image uploaded succesfully";
          this.snackbar_icon = "mdi-alert-circle";
          this.snackbar_show = true;
          this.personalInformation.image = response.result
        }

      } catch (error) {
        // The browser returns a CORS error but the request succeeds
        // This is a quick fix to avoid displaying a error message to
        // the user even if the request is successful
        if (response.success) return;
        this.snackbar_color = "error";
        this.snackbar_text = "Failed " + error;
        this.snackbar_icon = "mdi-alert-circle";
        this.snackbar_show = true;
      }
    },

    cvEscoV2RelationLabel(relation) {
      return cvEscoV2ReviewLib.relationLabelEs(relation)
    },
    cvEscoV2ConceptTypeBadge(conceptType) {
      const type = conceptType && typeof conceptType === 'object'
        ? cvEscoV2ReviewLib.resolvedConceptType(conceptType)
        : conceptType
      return cvEscoV2ReviewLib.conceptTypeBadgeEs(type)
    },
    cvEscoV2EvidenceSourceLabel(row) {
      return cvEscoV2ReviewLib.evidenceSourceLabelEs(cvEscoV2ReviewLib.evidenceSourceKind(row))
    },
    cvEscoV2EscoRowsBySource(kind, bucket) {
      const esco = (this.cvEscoV2Draft && this.cvEscoV2Draft.esco) || {}
      const rows = esco[bucket] || []
      return rows.filter((row) => cvEscoV2ReviewLib.evidenceSourceKind(row) === kind)
    },
    cvEscoV2EscoSectionsFor(rows) {
      const filter = (bucket) =>
        rows.filter((row) => cvEscoV2ReviewLib.escoFormBucket(row) === bucket)
      return [
        { key: 'skill', title: 'Skills (ESCO skill / knowledge)', rows: filter('skill') },
        { key: 'competence', title: 'Competences (CV extractor list only)', rows: filter('competence') }
      ]
    },
    cvEscoV2AppliedEscoFlatByFormBucket(bucket) {
      return (this.cvEscoV2AppliedEscoFlat || []).filter(
        (row) => cvEscoV2ReviewLib.escoFormBucket(row) === bucket
      )
    },
    cvEscoV2ExistingLabels(bucket) {
      if (bucket === 'skill') {
        return [].concat(this.skillsSelected || [], this.skillsSelectedAutocomplete || [])
      }
      if (bucket === 'competence') {
        return [].concat(this.competencesSelected || [], this.competencesSelectedAutocomplete || [])
      }
      if (bucket === 'job') {
        return [].concat(this.experiencesSelected || [], this.experiencesSelectedAutocomplete || [])
      }
      return []
    },
    cvEscoV2CheckedCatalogEntries(bucket) {
      return this.cvEscoV2AppliedEscoFlatByFormBucket(bucket)
        .filter((row) => row && row.checked && row.preferredLabel)
        .map((row) => String(row.preferredLabel).trim())
    },
    cvEscoV2TagsForUpdate(bucket, saved, manual) {
      return cvEscoV2ApplyLib.mergeProfileTags(
        saved,
        manual,
        this.cvEscoV2CheckedCatalogEntries(bucket)
      )
    },
    cvEscoV2SectionName(bucket) {
      if (bucket === 'skill') return 'Skills'
      if (bucket === 'competence') return 'Competences'
      if (bucket === 'job') return 'Job Experiences'
      return 'profile'
    },
    cvEscoV2FieldLabelMatching(row) {
      const wanted = String((row && row.preferredLabel) || '').trim().toLowerCase()
      if (!wanted) return ''
      const labels = this.cvEscoV2ExistingLabels(cvEscoV2ReviewLib.escoFormBucket(row))
      for (const label of labels) {
        const text = label && typeof label === 'object' ? label.label : label
        if (String(text || '').trim().toLowerCase() === wanted) return String(text).trim()
      }
      return ''
    },
    cvEscoV2EducationSuggestionCaption(row) {
      const parts = []
      if (row && row.university) parts.push(String(row.university))
      if (row && row.level) parts.push(String(row.level))
      const years = row && row.startAndEndYear
      if (years && years[0] && years[1]) parts.push(years[0] + ' — ' + years[1])
      return parts.join(' · ')
    },
    setCvEscoV2EducationChecked(row, checked) {
      if (!row) return
      if (checked) {
        const key = cvEscoV2ApplyLib.educationIdentityKey(row.name, row.university)
        const existing = (this.educationsSelected || []).find(
          (edu) => cvEscoV2ApplyLib.educationIdentityKey(edu.name, edu.university) === key
        )
        if (existing && key !== '\0') {
          row.checked = false
          this.snackbar_color = 'error'
          this.snackbar_text = (existing.name || row.name) + ' already exist in Education'
          this.snackbar_icon = 'mdi-alert-circle'
          this.snackbar_show = false
          this.$nextTick(() => {
            this.snackbar_show = true
          })
          return
        }
      }
      row.checked = !!checked
    },
    setCvEscoV2SuggestionChecked(row, checked) {
      if (!row) return
      if (checked) {
        const existing = this.cvEscoV2FieldLabelMatching(row)
        if (existing) {
          row.checked = false
          const section = this.cvEscoV2SectionName(cvEscoV2ReviewLib.escoFormBucket(row))
          this.snackbar_color = 'error'
          this.snackbar_text = existing + ' already exist in ' + section
          this.snackbar_icon = 'mdi-alert-circle'
          this.snackbar_show = false
          this.$nextTick(() => {
            this.snackbar_show = true
          })
          return
        }
      }
      row.checked = !!checked
    },
    clearCvEscoV2Suggestions(bucket) {
      this.cvEscoV2AppliedEscoFlat = (this.cvEscoV2AppliedEscoFlat || []).filter(
        (row) => cvEscoV2ReviewLib.escoFormBucket(row) !== bucket
      )
    },
    isCvEscoV2ReviewOptionChecked(evidenceId, uri) {
      if (!this.cvEscoV2Review) return false
      return cvEscoV2ReviewLib.isReviewOptionChecked(this.cvEscoV2Review.reviewedMatches, evidenceId, uri)
    },
    isCvEscoV2ReviewNoneChecked(evidenceId) {
      if (!this.cvEscoV2Review) return false
      return cvEscoV2ReviewLib.isReviewNoneChecked(this.cvEscoV2Review.reviewedMatches, evidenceId)
    },
    toggleCvEscoV2ReviewOption(evidenceId, uri, checked) {
      this.cvEscoV2Review.reviewedMatches = cvEscoV2ReviewLib.toggleReviewOption(
        this.cvEscoV2Review.reviewedMatches,
        evidenceId,
        uri,
        checked
      )
    },
    toggleCvEscoV2ReviewNone(evidenceId, checked) {
      this.cvEscoV2Review.reviewedMatches = cvEscoV2ReviewLib.toggleReviewNone(
        this.cvEscoV2Review.reviewedMatches,
        evidenceId,
        checked
      )
    },
    isCvEscoV2JobSelected(index) {
      return this.cvEscoV2Review &&
        this.cvEscoV2Review.selectedJobIndexes.indexOf(index) >= 0
    },
    toggleCvEscoV2Job(index, checked) {
      const arr = this.cvEscoV2Review.selectedJobIndexes.slice()
      const pos = arr.indexOf(index)
      if (checked && pos < 0) arr.push(index)
      if (!checked && pos >= 0) arr.splice(pos, 1)
      this.cvEscoV2Review.selectedJobIndexes = arr.sort((a, b) => a - b)
    },
    isCvEscoV2EducationSelected(index) {
      return this.cvEscoV2Review &&
        this.cvEscoV2Review.selectedEducationIndexes.indexOf(index) >= 0
    },
    cvEscoV2EducationGap(index, field) {
      const gaps = this.cvEscoV2Review && this.cvEscoV2Review.educationGaps
      return !!(gaps && gaps[index] && gaps[index][field])
    },
    cvEscoV2MatchNeedsChoice(evidenceId) {
      if (!this.cvEscoV2Review) return false
      const pick = this.cvEscoV2Review.reviewedMatches[evidenceId]
      if (pick === undefined) return true
      return Array.isArray(pick) && pick.filter((uri) => typeof uri === 'string' && uri).length === 0
    },
    cvEscoV2EducationFieldNeedsInput(index, field) {
      if (!this.isCvEscoV2EducationSelected(index)) return false
      const rows = (this.cvEscoV2Draft && this.cvEscoV2Draft.education) || []
      const missing = cvEscoV2ReviewLib.educationMissingFields(rows[index])
      if (field === 'level') return missing.level
      return this.cvEscoV2EducationGap(index, field) && !!missing[field]
    },
    cvEscoV2EducationNeedsInput(index) {
      if (!this.isCvEscoV2EducationSelected(index)) return false
      const rows = (this.cvEscoV2Draft && this.cvEscoV2Draft.education) || []
      return !cvEscoV2ReviewLib.educationRowComplete(rows[index])
    },
    toggleCvEscoV2Education(index, checked) {
      const arr = this.cvEscoV2Review.selectedEducationIndexes.slice()
      const pos = arr.indexOf(index)
      if (checked && pos < 0) arr.push(index)
      if (!checked && pos >= 0) arr.splice(pos, 1)
      this.cvEscoV2Review.selectedEducationIndexes = arr.sort((a, b) => a - b)
    },
    cancelCvEscoV2Review() {
      this.cvEscoV2ReviewOpen = false
      this.cvEscoV2Review = null
    },
    completeCvEscoV2Review() {
      if (!this.cvEscoV2ReviewComplete) return
      this.cvEscoV2ReviewedDraft = cvEscoV2ReviewLib.buildReviewedDraft(
        this.cvEscoV2Draft,
        this.cvEscoV2Review
      )
      const merged = cvEscoV2ApplyLib.applyReviewedDraftToForm({
        educationsSelected: this.educationsSelected,
        cvEscoV2AppliedEducations: this.cvEscoV2AppliedEducations,
        cvEscoV2AppliedJobs: this.cvEscoV2AppliedJobs,
        cvEscoV2AppliedConcepts: this.cvEscoV2AppliedConcepts,
        experiencesSelected: this.experiencesSelected,
        skillsSelected: this.skillsSelected,
        competencesSelected: this.competencesSelected
      }, this.cvEscoV2ReviewedDraft)
      this.cvEscoV2AppliedEducations = merged.cvEscoV2AppliedEducations
      this.cvEscoV2AppliedJobs = merged.cvEscoV2AppliedJobs
      this.cvEscoV2AppliedConcepts = merged.cvEscoV2AppliedConcepts
      this.cvEscoV2AppliedEscoFlat = cvEscoV2ApplyLib.stampFlatSuggestionChecks(
        cvEscoV2ApplyLib.mergeEscoFlatEntries(
          this.cvEscoV2AppliedEscoFlat,
          this.cvEscoV2ReviewedDraft.esco || []
        ),
        {
          skill: this.cvEscoV2ExistingLabels('skill'),
          competence: this.cvEscoV2ExistingLabels('competence'),
          job: this.cvEscoV2ExistingLabels('job')
        },
        cvEscoV2ReviewLib.escoFormBucket
      )
      this.cvEscoV2ReviewOpen = false
      this.cvEscoV2Review = null
      this.snackbar_color = 'success'
      this.snackbar_text = 'Review applied to the form (not saved on the server)'
      this.snackbar_icon = 'mdi-check'
      this.snackbar_show = true
    },
    formatCvProcessDuration(ms) {
      if (ms == null || !Number.isFinite(ms)) return '—'
      const total = Math.max(0, Math.round(ms / 1000))
      const minutes = Math.floor(total / 60)
      const seconds = total % 60
      return minutes + ':' + String(seconds).padStart(2, '0')
    },
    startCvProcessClock() {
      this.stopCvProcessClock()
      this._cvProcessTimer = setInterval(() => {
        this.cvProcessNow = Date.now()
      }, 250)
    },
    stopCvProcessClock() {
      if (this._cvProcessTimer) clearInterval(this._cvProcessTimer)
      this._cvProcessTimer = null
    },
    cancelCvProcess() {
      if (this._cvProcessAbort) this._cvProcessAbort.abort()
    },
    applyCvProcessEvent(event) {
      if (!event || typeof event !== 'object') return null
      if (event.type === 'phase' && event.phase === 'reading') {
        this.cvProcessPhase = 'reading'
        return null
      }
      if (event.type === 'search') {
        this.cvProcessPhase = 'searching'
        this.cvProcessDone = event.done
        this.cvProcessTotal = event.total
        if (event.searchMs != null) this.cvProcessSearchMs.push(event.searchMs)
        return null
      }
      if (event.type === 'error') throw new Error(event.message || 'Error')
      if (event.type === 'done') return event.result
      return null
    },
    async readCvEscoV2Process(signal) {
      const response = await fetch(process.env.VUE_APP_API_ENDPOINT + 'people/cv-esco-v2/process', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Auth-Token': this.$cookie.get('jwt_token')
        },
        body: '{}',
        signal
      })
      if (!response.body || !response.body.getReader) {
        const body = await response.json()
        if (!body.success) throw new Error(body.message || 'Error')
        return body.result
      }
      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let buffer = ''
      let result = null
      const take = (line) => {
        const text = line.trim()
        if (!text) return
        if (text.startsWith('{') && text.includes('"success"') && !text.includes('"type"')) {
          const body = JSON.parse(text)
          if (!body.success) throw new Error(body.message || 'Error')
          result = body.result
          return
        }
        const eventResult = this.applyCvProcessEvent(JSON.parse(text))
        if (eventResult) result = eventResult
      }
      let chunk = await reader.read()
      while (!chunk.done) {
        buffer += decoder.decode(chunk.value, { stream: true })
        const lines = buffer.split('\n')
        buffer = lines.pop()
        lines.forEach(take)
        chunk = await reader.read()
      }
      if (buffer.trim()) take(buffer)
      if (!result) throw new Error('The server response does not have the expected format.')
      return result
    },
    async processCvEscoV2() {
      this.cvEscoV2Loading = true
      this.cvEscoV2Draft = null
      this.cvEscoV2Review = null
      this.cvEscoV2ReviewOpen = false
      this.cvEscoV2DraftSource = 'pdf'
      this.cvProcessPhase = 'reading'
      this.cvProcessDone = 0
      this.cvProcessTotal = 0
      this.cvProcessSearchMs = []
      this.cvProcessStartedAt = Date.now()
      this.cvProcessNow = this.cvProcessStartedAt
      this.cvProcessOpen = true
      this.startCvProcessClock()
      const abort = new AbortController()
      this._cvProcessAbort = abort
      try {
        const result = await this.readCvEscoV2Process(abort.signal)
        if (!cvEscoV2ReviewLib.validateDraftShape(result)) {
          throw new Error('The server response does not have the expected format.')
        }
        this.cvEscoV2Draft = cvEscoV2ReviewLib.omitIscoOccupationSuggestions(result)
        this.cvEscoV2Review = cvEscoV2ReviewLib.initReviewState(this.cvEscoV2Draft)
        this.cvProcessOpen = false
        this.cvEscoV2ReviewOpen = true
      } catch (error) {
        if (error && error.name === 'AbortError') return
        this.snackbar_color = 'error'
        this.snackbar_text = error.message
        this.snackbar_icon = 'mdi-alert-circle'
        this.snackbar_show = true
      } finally {
        this.stopCvProcessClock()
        this.cvProcessOpen = false
        this.cvEscoV2Loading = false
        this._cvProcessAbort = null
      }
    },

    triggerEuropassImport() {
      if (this.$refs.europassFileInput) this.$refs.europassFileInput.click()
    },

    async onEuropassFileSelected(event) {
      const input = event && event.target
      const file = input && input.files && input.files[0]
      if (input) input.value = ''
      if (!file) return
      await this.importEuropassFile(file)
    },

    async readEuropassImportProcess(file, signal) {
      const formData = new FormData()
      formData.append('europass', file, file.name)
      const response = await fetch(process.env.VUE_APP_API_ENDPOINT + 'people/europass/import', {
        method: 'POST',
        headers: {
          'Auth-Token': this.$cookie.get('jwt_token')
        },
        body: formData,
        signal
      })
      if (!response.body || !response.body.getReader) {
        const body = await response.json()
        if (!body.success) throw new Error(body.message || 'Error')
        return body.result
      }
      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let buffer = ''
      let result = null
      const take = (line) => {
        const text = line.trim()
        if (!text) return
        if (text.startsWith('{') && text.includes('"success"') && !text.includes('"type"')) {
          const body = JSON.parse(text)
          if (!body.success) throw new Error(body.message || 'Error')
          result = body.result
          return
        }
        const eventResult = this.applyCvProcessEvent(JSON.parse(text))
        if (eventResult) result = eventResult
      }
      let chunk = await reader.read()
      while (!chunk.done) {
        buffer += decoder.decode(chunk.value, { stream: true })
        const lines = buffer.split('\n')
        buffer = lines.pop()
        lines.forEach(take)
        chunk = await reader.read()
      }
      if (buffer.trim()) take(buffer)
      if (!result) throw new Error('The server response does not have the expected format.')
      return result
    },

    async importEuropassFile(file) {
      this.europassImportLoading = true
      this.cvEscoV2Draft = null
      this.cvEscoV2Review = null
      this.cvEscoV2ReviewOpen = false
      this.cvEscoV2DraftSource = 'europass'
      this.cvProcessPhase = 'reading'
      this.cvProcessDone = 0
      this.cvProcessTotal = 0
      this.cvProcessSearchMs = []
      this.cvProcessStartedAt = Date.now()
      this.cvProcessNow = this.cvProcessStartedAt
      this.cvProcessOpen = true
      this.startCvProcessClock()
      const abort = new AbortController()
      this._cvProcessAbort = abort
      try {
        const result = await this.readEuropassImportProcess(file, abort.signal)
        if (!cvEscoV2ReviewLib.validateDraftShape(result)) {
          throw new Error('The server response does not have the expected format.')
        }
        this.cvEscoV2Draft = cvEscoV2ReviewLib.omitIscoOccupationSuggestions(result)
        this.cvEscoV2Review = cvEscoV2ReviewLib.initReviewState(this.cvEscoV2Draft)
        this.cvProcessOpen = false
        this.cvEscoV2ReviewOpen = true
      } catch (error) {
        if (error && error.name === 'AbortError') return
        this.snackbar_color = 'error'
        this.snackbar_text = error.message
        this.snackbar_icon = 'mdi-alert-circle'
        this.snackbar_show = true
      } finally {
        this.stopCvProcessClock()
        this.cvProcessOpen = false
        this.europassImportLoading = false
        this._cvProcessAbort = null
      }
    },

    buildEuropassExportProfile() {
      const jobs = []
      const seenJobs = new Set()
      for (const row of this.cvEscoV2AppliedOccupationEntries || []) {
        if (!row || row.checked === false) continue
        const label = row.preferredLabel || row.evidence || ''
        const key = String(label).toLowerCase()
        if (!label || seenJobs.has(key)) continue
        seenJobs.add(key)
        jobs.push({
          occupation: label,
          company: '',
          uri: row.uri || '',
          start: '',
          end: ''
        })
      }
      for (const row of this.cvEscoV2AppliedJobs || []) {
        const occupation = (row && row.occupation) || ''
        const key = String(occupation).toLowerCase()
        if (!occupation || seenJobs.has(key)) continue
        seenJobs.add(key)
        jobs.push({
          occupation,
          company: (row && row.company) || '',
          start: (row && row.start) || '',
          end: (row && row.end) || '',
          uri: (row && row.uri) || ''
        })
      }
      for (const label of [].concat(this.experiencesSelected || [], this.experiencesSelectedAutocomplete || [])) {
        const occupation = typeof label === 'string' ? label : (label && (label.name || label.label)) || ''
        const key = String(occupation).toLowerCase()
        if (!occupation || seenJobs.has(key)) continue
        seenJobs.add(key)
        jobs.push({ occupation, company: '', start: '', end: '', uri: (label && label.uri) || '' })
      }

      const escoConcepts = (this.cvEscoV2AppliedEscoFlat || [])
        .filter((row) => row && row.checked !== false && row.uri)
        .map((row) => ({
          uri: row.uri,
          preferredLabel: row.preferredLabel || row.evidence || '',
          conceptType: row.conceptType || ''
        }))

      const education = []
        .concat(this.educationsSelected || [])
        .concat((this.cvEscoV2AppliedEducations || []).filter((row) => row && row.checked !== false))
        .map((edu) => ({
          title: (edu && (edu.name || edu.title || edu.level)) || '',
          university: (edu && edu.university) || '',
          start: (edu && (edu.start || edu.start_year)) || '',
          end: (edu && (edu.end || edu.end_year)) || ''
        }))

      return {
        personal: {
          fullName: this.personalInformation.fullName,
          email: this.personalInformation.email,
          city: this.personalInformation.city,
          country: this.personalInformation.country,
          phone: this.personalInformation.phone
        },
        jobs,
        skills: [].concat(this.skillsSelected || [], this.skillsSelectedAutocomplete || []),
        competences: [].concat(this.competencesSelected || [], this.competencesSelectedAutocomplete || []),
        education,
        escoConcepts
      }
    },

    async exportEuropass(format) {
      this.europassExportLoading = true
      try {
        const response = await fetch(process.env.VUE_APP_API_ENDPOINT + 'people/europass/export', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Auth-Token': this.$cookie.get('jwt_token')
          },
          body: JSON.stringify({
            format: format === 'xml' ? 'xml' : 'json',
            profile: this.buildEuropassExportProfile()
          })
        })
        if (!response.ok) {
          let message = 'Export failed'
          try {
            const body = await response.json()
            message = body.message || message
          } catch (error) { /* ignore */ }
          throw new Error(message)
        }
        const blob = await response.blob()
        const url = URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = format === 'xml' ? 'europass-profile.xml' : 'europass-profile.json'
        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)
        URL.revokeObjectURL(url)
        this.snackbar_color = 'success'
        this.snackbar_text = 'Europass export downloaded'
        this.snackbar_icon = 'mdi-check'
        this.snackbar_show = true
      } catch (error) {
        this.snackbar_color = 'error'
        this.snackbar_text = error.message
        this.snackbar_icon = 'mdi-alert-circle'
        this.snackbar_show = true
      } finally {
        this.europassExportLoading = false
      }
    },

    async uploadCV() {
      let response;
      try {
        if (this.cvData.cv != null) {
          let formData = new FormData();
          formData.append("cv", this.cvData.cv, this.cvData.cv.name);
          formData.append("userId", this.personalInformation.user_id);
          // Remove the file from the browser
          this.imageData.image = null;

          response = await fetch(
            process.env.VUE_APP_API_ENDPOINT + "people/upload-cv",
            {
              method: "POST",
              body: formData,
              headers: {
                "Auth-Token": this.$cookie.get("jwt_token"),
              },
            }
          );
          if (response.success) {
            this.snackbar_color = "success";
            this.snackbar_text = "CV uploaded succesfully";
            this.snackbar_icon = "mdi-alert-circle";
            this.snackbar_show = true;
          }
        }
      } catch (error) {
        // The browser returns a CORS error but the request succeeds
        // This is a quick fix to avoid displaying a error message to
        // the user even if the request is successful
        if (response.success) return;
        this.snackbar_color = "error";
        this.snackbar_text = "Failed " + error;
        this.snackbar_icon = "mdi-alert-circle";
        this.snackbar_show = true;
      }
    },
    async deleteCV() {
      let response;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT + "people/delete-cv",
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
          }
        );
        response = await response.json();
        if (response.success) {
          this.snackbar_color = "success";
          this.snackbar_text = "CV deleted succesfully";
          this.snackbar_icon = "mdi-alert-circle";
          this.snackbar_show = true;
          // Update the displayed data
          await this.getData();
        }
      } catch (error) {
        this.snackbar_color = "error";
        this.snackbar_text = error.message;
        this.snackbar_icon = "mdi-alert-circle";
        this.snackbar_show = true;
      }
    },
    deleteChallenge(challengeName) {
      for (const i in this.challengesSelected) {
        if (this.challengesSelected[i] === challengeName) {
          this.challengesSelected.splice(i, 1);
        }
      }
    },
    async updateUserExperiences() {
      this.markProfileSectionUpdating('experiences');
      const newExperiences = this.cvEscoV2TagsForUpdate(
        "job",
        this.experiencesSelected,
        this.experiencesSelectedAutocomplete
      );
      let response;
      let saved = false;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT +
            "v2/people/user-profile/user-experiences",
          {
            method: "PUT",
            body: JSON.stringify({ experiences: newExperiences }),
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
          }
        );
        response = await response.json();
        if (response.success) {
          saved = true;
          this.snackbar_color = "success";
          this.snackbar_text = "Experiences updated";
          this.snackbar_icon = "mdi-check";
          this.snackbar_show = true;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        this.snackbar_color = "error";
        this.snackbar_text = (response && response.message) || error.message;
        this.snackbar_icon = "mdi-alert-circle";
      }
      this.snackbar_show = true;
      if (!saved) {
        this.clearProfileSectionStatus('experiences');
        return;
      }
      this.experiencesSelectedAutocomplete = [];
      this.clearCvEscoV2Suggestions("job");
      await this.getData();
      this.markProfileSectionUpdated('experiences');
    },
  },
};
</script>

<style>
.card-form {
  margin: 25px;
}

.profile-cards > .card-form {
  margin-bottom: 0;
}

.profile-cards > .card-form + .card-form {
  margin-top: 30px;
}

.profile-cards > .card-form > .row:last-child {
  margin-bottom: 0;
}

.white-icon {
  color: white !important;
}

h3:first-letter {
  text-transform: capitalize;
}

.v-treeview-node__label {
  text-transform: capitalize;
  word-wrap: break-word;
  white-space: initial;
}

.wrapper {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
}

.display-inline {
  display: inline-block;
}

.input {
  max-width: 300px;
  display: inline-block;
  margin: 20px;
  margin-bottom: 40px;
}

.background-gradient {
  color: white;
  box-shadow: 0 0 20px #eee;
  background-image: linear-gradient(to right, #047ec3 0%, #52ae32 200%);
}

.text-gradient-half {
  background: linear-gradient(to right, #047ec3 0%, #52ae32 150%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.cv-suggestion-chip {
  height: 32px;
  cursor: pointer;
}

.profile-suggestion-list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 5px 20px;
  justify-content: center;
}

.profile-suggestion-item {
  flex: 0 1 auto;
  max-width: 100%;
  justify-items: center;
  width: min-content;
  text-align: center;
}

.profile-suggestion-from {
  font-size: 0.65rem !important;
  line-height: 0.75rem;
  margin-top: 2px;
  padding-bottom: 4px;
}

.cv-suggestion-check {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  margin-right: 6px;
  margin-bottom: 2px; 
  cursor: pointer;
  flex: 0 0 auto;
  box-sizing: border-box;
  border: thin solid currentColor;
  border-radius: 2px;
}

.cv-suggestion-chip .cv-suggestion-check__mark {
  position: absolute;
  color: #52ae32 !important;
  font-size: 15px;
  -webkit-text-stroke: 0.7px #52ae32;
  width: -webkit-fill-available !important;
}

.profile-card-search.v-input {
  box-sizing: border-box;
  border: thin solid currentColor;
  border-radius: 10px;
}

.profile-card-search .v-input__prepend-outer {
  margin-right: 0;
  margin-left: 12px;
}

.profile-card-search .profile-search-chip.profile-search-chip--duplicate {
  background-color: #f9c5c5 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.profile-search-chip__struck {
  text-decoration: line-through;
}

.profile-search-errors {
  list-style: disc;
  margin: 8px 0 0;
  padding-left: 1.25rem;
  color: var(--v-error-base);
  font-weight: bold;
}

.profile-search-errors li + li {
  margin-top: 4px;
}

.sugestion-title{
  justify-self: anchor-center;
  font-size: large !important;
  margin-top: 10px;
}

.sugestion-subtitle{
  justify-self: anchor-center;
  font-size: small !important;
}

.cv-review-choice {
  border: 1px solid #f59302;
  border-radius: 4px;
}

.cv-review-choice--pending {
  border-color: #f59302;
}

.cv-review-choice--done {
  border-color: #067ec3;
}

.cv-review-action-icon--pending {
  color: #f59302 !important;
}

.cv-review-action-icon--done {
  color: #067ec3 !important;
}

.cv-review-pending-note {
  color: #f59302;
  font-size: 0.875rem;
}

.cv-review-dialog__title {
  border-bottom: thin solid rgba(255, 255, 255, 0.35);
  padding-bottom: 14px;
  color: white;
}

.v-dialog > .v-card > .v-card__text.cv-review-dialog__body {
  padding-top: 24px;
}

.cv-review-dialog__actions {
  border-top: thin solid rgba(0, 0, 0, 0.12);
  padding: 12px 20px;
}
</style>
